import{componentFactory,datasetFactory}from'../../../fc-core/src/lib';import Entities from'../dataset/entities';import Markers from'../dataset/markers';import MapGroup from'../dataset/groups/map-group';export default function(a){var b,c=a.getFromEnv('dataSource'),d=c.data||{},e=c.markers;componentFactory(a,MapGroup,'mapGroup'),b=a.getChildren('mapGroup')[0],datasetFactory(b,Entities,'entities',1,[d]),e?datasetFactory(b,Markers,'markers',1,[e]):a.getDatasets()[1]&&a.getDatasets()[1].remove()}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fusioncharts/vendors/fc-maps/src/factories/maps-dataset.js
// module id = null
// module chunks = 